// Inline error for upload-validation failures.
// Pairs with the { errorKey, params } object returned by lib/fileValidation.js
// so callers can pass it through unmodified.

import { useTranslation } from '../i18n';

export function FileError({ errorKey, params, className }) {
  const { t } = useTranslation();
  if (!errorKey) return null;
  return (
    <div
      className={'file-error' + (className ? ` ${className}` : '')}
      role="alert"
    >
      <span aria-hidden="true">⚠️</span>
      <span>{t(errorKey, params)}</span>
    </div>
  );
}
